import type {GroupBy, SortDirection} from './types';

export const getPerfNow = () =>
  typeof performance !== 'undefined' && typeof performance.now === 'function'
    ? performance.now()
    : Date.now();

export const toPerfGroupBy = (groupBy: GroupBy | string | null | undefined) =>
  groupBy && groupBy !== 'none' ? groupBy : 'none';

export const toPerfScopeValue = (scopeValue?: string | null) => scopeValue ?? '';

export const buildWorkstreamV2QueryPerfSignature = ({
  activeGroup,
  filtersParam,
  groupBy,
  scopeType,
  scopeValue,
  sortColumn,
  sortDirection,
}: {
  activeGroup?: string | null;
  filtersParam?: string;
  groupBy?: GroupBy;
  scopeType: string;
  scopeValue?: string | null;
  sortColumn?: string | null;
  sortDirection?: SortDirection;
}) =>
  JSON.stringify({
    activeGroup: activeGroup ?? 'all',
    filtersParam: filtersParam ?? '',
    groupBy: toPerfGroupBy(groupBy),
    scopeType,
    scopeValue: toPerfScopeValue(scopeValue),
    sortColumn: sortColumn ?? 'none',
    sortDirection: sortDirection ?? 'none',
  });
